// 2. Create the CreatePositionButton component
// components/Position/CreatePositionButton.jsx

import React from 'react';
import styles from './CreatePosition.module.css';

function CreatePositionButton({ onClick }) {
  return (
    <button 
      className={styles.createPositionBtn}
      onClick={onClick}
    >
      <span className={styles.buttonIcon}>+</span>
      Add Position
    </button>
  );
}

export default CreatePositionButton;